import React from 'react'
import styles from '@/pages/webtalkDetail/index.module.scss'
import BusinessDetailFrame from '@/next/BusinessDetailFrame'

// Next variant of src/pages/webtalkDetail; the business origin is rewritten at build time.
const businessWebUrl = 'https://combine-next.jarvisbro.com'

const WebtalkDetail: React.FC = () => (
    <BusinessDetailFrame
        origin={businessWebUrl}
        path="/ai/call/details/webtalk"
        page="talk-detail"
        title="WebtalkDetail"
        styles={{ container: styles.webtalkDetailContainer, loading: styles.loadingContainer, iframe: styles.webtalkDetailIframe }}
    />
)

export default WebtalkDetail
